import _ from 'lodash';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

class PrintJobEdit extends Component {
  constructor(props) {
    super(props);
    // using uncontrolled textarea and forgoing set state for perf on large payloads
    let secure = false;
    try {
      const payload = JSON.parse(props.payload);
      secure = _.get(payload, 'template.secure');
      this.payload = JSON.stringify(payload, null, 2);
    } catch (e) {
      this.error = e.message;
    }

    this.state = {
      loading: false,
      secure,
    };
  }

  handleSubmit(payload) {
    this.setState({ loading: true });
    this.props.handleSubmit(payload).finally(() => this.setState({ loading: false }));
  }

  renderTextArea() {
    if (this.error) {
      return <div>{this.error}</div>;
    }

    return (
      <textarea
        style={{ flexGrow: 1, backgroundColor: '#EEE' }}
        defaultValue={this.payload}
        onChange={(e) => { this.payload = e.target.value; }}
        readOnly={this.state.secure}
      />
    );
  }

  renderSubmit() {
    if (this.error || this.state.secure) {
      return null;
    }

    return (
      <Button
        variant="primary"
        className="float-right"
        onClick={() => { this.handleSubmit(this.payload); }}
        disabled={this.state.loading}
      >
        Submit
      </Button>
    );
  }

  render() {
    const { id } = this.props;

    return (
      <div className="content-container">
        <h5>Id: {id}
          {this.renderSubmit()}
        </h5>
        {this.renderTextArea()}
      </div>
    );
  }
}

PrintJobEdit.defaultProps = {
  payload: {},
};

PrintJobEdit.propTypes = {
  id: PropTypes.string,
  payload: PropTypes.string,
  handleSubmit: PropTypes.func,
};

export default PrintJobEdit;
